module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaAQMAAACThN6NAAAABlBMVEX///+ZmZmOUEqyAAAAEElEQVQI12OgCPw/ACEoAQDjvwN/PjWeTQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_minus2.png
// module id = lbO6
// module chunks = 9